import { updateObject, toggleItem } from '../utility';
import {
	ADD_SAMPLE,
	REMOVE_SAMPLE,
	CLEAR_SAMPLES,
	UPDATE_SAMPLE_CART,
	REMOVE_POST,
} from '../types/sampleCart';

const serverConfiguration = JSON.parse(document.getElementById('server-state').innerHTML);

const initialState = {
	products: serverConfiguration.initialState.sampleCart || [],
};

const toggleSample = (state, action) => {
	const endpoint = serverConfiguration.endpoints[
		state.products.indexOf(action.id) > -1
			? 'endpointRemoveSample'
			: 'endpointAddSample'
	];

	fetch(endpoint, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			id: action.id,
		}),
	}).catch((error) => {
		console.error(error);
	});

	return updateObject(state, {
		products: toggleItem(state.products, action.id),
	});
};

const clearSamples = (state) => {
	return updateObject(state, {
		products: [],
	});
};

// This should be part of a separate API folder of functions
const removePOST = (state, id) => {
	const endpoint = serverConfiguration.endpoints.endpointRemoveSample;

	fetch(endpoint, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			id,
		}),
	}).catch((error) => {
		console.error(error);
	});

	return state;
};

const updateSampleCart = (state, samples) => {
	return updateObject(state, {
		products: [...samples],
	});
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case ADD_SAMPLE:
		case REMOVE_SAMPLE:
			return toggleSample(state, action);
		case CLEAR_SAMPLES:
			return clearSamples(state);
		case UPDATE_SAMPLE_CART:
			return updateSampleCart(state, action.samples);
		case REMOVE_POST:
			return removePOST(state, action.id);
		default:
			return state;
	}
};

export default reducer;
